import { Link, Tooltip } from '@heroui/react';
import { IPortfolioForm } from '../../portfolioTypes';
import { useEffect, useRef, useState } from 'react';

// Create a separate component for the tooltip link
const TooltipLink: React.FC<{
	item: IPortfolioForm;
	clickItemLink: (id: number | string) => void;
}> = ({ item, clickItemLink }) => {
	const linkRef = useRef<HTMLAnchorElement>(null);
	const [showTooltip, setShowTooltip] = useState(false);

	useEffect(() => {
		if (linkRef.current) {
			const isOverflowing = linkRef.current.scrollWidth > linkRef.current.clientWidth;
			setShowTooltip(isOverflowing);
		}
	}, [item.name]);

	const linkElement = (
		<Link
			ref={linkRef}
			className="cursor-pointer text-small text-msi-darkblue-color-300 hover:underline truncate block w-full"
			onPress={() => clickItemLink(item.id ?? item.tempId ?? 'undefined-id')}
		>
			{item.name}
		</Link>
	);

	return showTooltip ? (
		<div className="w-full overflow-hidden">
			<Tooltip
				content={item.name}
				placement="top-start"
				delay={0}
				offset={3}
				closeDelay={0}
				classNames={{
					content: 'text-msi-darkblue-color-300 max-w-xs break-words whitespace-normal rounded',
					base: '-ml-2 transition-opacity duration-75',
				}}
			>
				{linkElement}
			</Tooltip>
		</div>
	) : (
		<div className="w-full overflow-hidden">{linkElement}</div>
	);
};

export default TooltipLink;
